module.exports = __webpack_public_path__ + "static/IBMPlexMono-Bold-39b60011d37acc66485d8a4eb76f24f5.woff2";